import { useAppSelector } from '../hooks';
import { getIsAuthenticated } from '../slices/authSlice';

export const useAuthState = () => {
  return {
    isAuthenticated: useAppSelector(getIsAuthenticated),
  };
};
